import styled from "styled-components";
import Skeleton from "../skeletons/Skeleton";
import GoogleMaps from "./GoogleMaps";
import { useContext, useState } from "react";
import LayoutContext from "../../../contexts/LayoutContext";
import { getCoordinates } from "../../../utils/helperFunctions";
import { getDistanceBetweenCoordinates } from "../../../utils/LocationLib";
import AppContext from "../../../contexts/AppContext";
import Bulb from "../../../assets/images/bulb.png";
import Check from "../../../assets/images/Checkbox.png";
import StoreSkeleton from "../skeletons/StoreSkeleton";
import EmptyStoresPanel from "./EmptyCheckoutPanel";
import momentTimeZone from "moment-timezone";

/* #region STYLED CSS */
const StorePanelStyles = styled.div`
    &.settings,
    &.settings * {
        box-sizing: border-box;
    }
    &.settings {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        height: 99%;
        position: relative;
        width: 100%;
    }
    .panel-headers {
        align-self: stretch;
        flex-shrink: 0;
        height: 32px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .order-nr-321325-j {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--heading-3-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--heading-3-font-size, 16px);
        line-height: var(--heading-3-line-height, 24px);
        font-weight: var(--heading-3-font-weight, 600);
        position: relative;
        flex: 1;
    }
    .btn-xs-secondary {
        background: var(--buttons-button-secondary, #212121);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
        cursor: pointer;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .separator {
        width: 100%;
        height: 0.5px;
        background-color: rgb(56, 56, 56);
    }

    .tabs-level-1 {
        opacity: 0.5;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .tabs-levels {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .buttons-fixed-width {
        background: var(--buttons-button-secondary-active, #373737);
        border-radius: 5px 0px 0px 5px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 36px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
        cursor: pointer;
    }
    .buttons-after {
        background: var(--buttons-button-secondary, #212121);
        border-radius: 5px 0px 0px 5px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 36px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
        cursor: pointer;
    }
    .label {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--button-text-small-semibold-font-size, 12px);
        line-height: var(--button-text-small-semibold-line-height, 16px);
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .buttons-fixed-width2 {
        background: var(--buttons-button-secondary, #212121);
        border-radius: 0px 5px 5px 0px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 36px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
        cursor: pointer;
    }
    .buttons-width2 {
        background: var(--buttons-button-secondary-active, #373737);
        cursor: pointer;
        border-radius: 0px 5px 5px 0px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 36px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
    }
    .label-active {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .map {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .buttons {
        border-radius: 5px;
        flex-shrink: 0;
        width: 100%;
        height: 28.5px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .rectangle {
        background: var(--surface-surface-tertiary, #212121);
        border-radius: 17.5px;
        width: 189px;
        height: 12.25px;
        position: absolute;
        left: calc(50% - 94.5px);
        top: calc(50% - 6.25px);
    }
    .btn-lg-solid,
    .btn-lg-solid * {
        box-sizing: border-box;
    }
    .btn-lg-solid {
        background: var(--buttons-button-primary, #f7665f);
        border-radius: 5px;
        padding: 0px 48px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 44px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
        width: 100%;
        opacity: 0.3;
    }
    .btn-solid {
        background: var(--buttons-button-primary, #f7665f);
        border-radius: 5px;
        padding: 0px 48px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 44px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
        width: 100%;
        cursor: pointer;
    }
    .frame-29590 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-medium-regular-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-medium-regular-font-size, 14px);
        line-height: var(--button-text-medium-regular-line-height, 24px);
        font-weight: var(--button-text-medium-regular-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .frame-313568,
    .frame-313568 * {
        box-sizing: border-box;
    }
    .frame-313568 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313474 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .available-stores {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 22px;
        line-height: 28px;
        font-weight: 600;
        position: relative;
        flex: 1;
    }
    .btn-xs-secondary {
        background: var(--buttons-button-secondary, #212121);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .line-26 {
        margin-top: -0.5px;
        border-style: solid;
        border-color: var(--border-border-tertiary, #373737);
        border-width: 0.5px 0 0 0;
        flex-shrink: 0;
        width: 372px;
        height: 0px;
        position: relative;
        transform-origin: 0 0;
        transform: rotate(0.001deg) scale(1, 1);
    }
    .tabs-level-2 {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .label {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--button-text-small-semibold-font-size, 12px);
        line-height: var(--button-text-small-semibold-line-height, 16px);
        font-weight: var(--button-text-small-semibold-font-weight, 600);
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .label-active {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .map {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 641.49px;
        position: relative;
        overflow: hidden;
    }
    .frame-295922861 {
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .image-156 {
        border-radius: 5px;
        width: 382px;
        height: 641px;
        position: absolute;
        left: 0px;
        top: -0.01px;
        object-fit: cover;
    }
    .tooltip-background {
        background: rgba(18, 18, 18, 0.8);
        border-radius: 5px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 350px;
        position: absolute;
        left: calc(50% - 175px);
        top: 15.99px;
        box-shadow: 4px 4px 87.4px 0px rgba(0, 0, 0, 1);
        backdrop-filter: blur(15px);
        z-index: 1;
    }
    .frame-313703 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-29476 {
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        position: relative;
    }
    .ellipse-86 {
        background: var(--wrap-wrap-orange, rgba(255, 153, 0, 0.1));
        border-radius: 50%;
        width: 32px;
        height: 32px;
        position: absolute;
        left: 0px;
        top: 0px;
    }
    .frame-29475 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 18px;
        position: absolute;
        left: calc(50% - 10px);
        top: calc(50% - 9px);
    }
    .lightbulb-02 {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
    }
    .frame-313702 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-313704 {
        display: flex;
        flex-direction: column;
        gap: 2px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .tooltip-text {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .location-option-cardtrigger {
        background: var(--surface-surface-appcard, #1e2125);
        border-radius: 16px;
        padding: var(--spacings-lg, 16px) 16px var(--spacings-lg, 16px) 16px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        position: absolute;
        bottom: 0px;
        box-shadow: var(--dropshadow-pop-up-box-shadow, 4px 4px 100px 0px rgba(0, 0, 0, 0.5));
        z-index: 1;
        margin-bottom: 16px;
    }
    .frame-295922853 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .luan-j-shirt-cosmic-4-2 {
        border-radius: 5px;
        flex-shrink: 0;
        width: 60px;
        height: 60px;
        position: relative;
        object-fit: cover;
    }
    .frame-313869 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .frame-313868 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .gant-bogstadveien {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--body-bodytext-bold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--body-bodytext-bold-font-size, 14px);
        line-height: var(--body-bodytext-bold-line-height, 21px);
        font-weight: var(--body-bodytext-bold-font-weight, 600);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .bogstadveien-37-0366-oslo-norwaydawdawdaw {
        color: var(--text-text-secondary, #8c8c94);
        text-align: left;
        font-family: var(--label-labeltext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--label-labeltext-font-size, 14px);
        line-height: var(--label-labeltext-line-height, 17px);
        font-weight: var(--label-labeltext-font-weight, 400);
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: break-spaces;
        width: 90%;
    }
    .map-pins {
        flex-shrink: 0;
        width: 55px;
        height: 55px;
        position: absolute;
        left: calc(50% - 27px);
        top: calc(50% - 27.18px);
    }
    .ellipse-88 {
        background: var(--surface-surface-overlay, rgba(13, 13, 13, 0.8));
        border-radius: 50%;
        border-style: solid;
        border-color: var(--border-border-brand, #f7665f);
        border-width: 1px;
        width: 78.18%;
        height: 78.18%;
        position: absolute;
        right: 10.91%;
        left: 10.91%;
        bottom: 10.91%;
        top: 10.91%;
    }
    .ellipse-87 {
        background: var(--color-gray-white-600, #ffffff);
        border-radius: 50%;
        border-style: solid;
        border-color: var(--border-border-brand, #f7665f);
        border-width: 7px;
        width: 30.91%;
        height: 30.91%;
        position: absolute;
        right: 34.55%;
        left: 34.55%;
        bottom: 34.55%;
        top: 34.55%;
    }
    .store-pin {
        flex-shrink: 0;
        width: 38.4px;
        height: 38.4px;
        position: absolute;
        left: 103px;
        top: 159.99px;
        overflow: visible;
    }
    .store-pin2 {
        flex-shrink: 0;
        width: 38.4px;
        height: 38.4px;
        position: absolute;
        left: calc(50% - -62px);
        top: calc(50% - 232.75px);
        overflow: visible;
    }
    .store-pin3 {
        flex-shrink: 0;
        width: 38.4px;
        height: 38.4px;
        position: absolute;
        left: calc(50% - -98px);
        top: calc(50% - 64.75px);
        overflow: visible;
    }
    .store-pin4 {
        flex-shrink: 0;
        width: 38.4px;
        height: 38.4px;
        position: absolute;
        left: calc(50% - 107px);
        top: calc(50% - -107.25px);
        overflow: visible;
    }
`;
const ListStyle = styled.div`
    .location-option-cardtrigger,
    .location-option-cardtrigger * {
        box-sizing: border-box;
    }
    .location-option-cardtrigger {
        background: var(--surface-surface-appcard, #1e2125);
        border-radius: 16px;
        padding: var(--spacings-lg, 16px) 16px var(--spacings-lg, 16px) 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        box-shadow: var(--60-24-card-box-shadow, 0px 24px 60px 0px rgba(0, 0, 0, 0.08));
    }
    .frame-295922853 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .luan-j-shirt-cosmic-4-2 {
        border-radius: 5px;
        flex-shrink: 0;
        width: 60px;
        height: 60px;
        position: relative;
        object-fit: cover;
    }
    .frame-313869 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .frame-313868 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .gant-bogstadveien {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--body-bodytext-bold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--body-bodytext-bold-font-size, 14px);
        line-height: var(--body-bodytext-bold-line-height, 21px);
        font-weight: var(--body-bodytext-bold-font-weight, 600);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .bogstadveien-37-0366-oslo-norwaydawdawdaw {
        color: var(--text-text-secondary, #8c8c94);
        text-align: left;
        font-family: var(--label-labeltext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--label-labeltext-font-size, 14px);
        line-height: var(--label-labeltext-line-height, 17px);
        font-weight: var(--label-labeltext-font-weight, 400);
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: break-spaces;
    }
    .checkbox-label {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .ellipse-2 {
        border-radius: 50%;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 2px;
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        position: relative;
    }
`;
export default function StorePanel() {
    const [selectBtn, setSelectBtn] = useState("map");
    const [storePopupInformation, setStorePopupInformation] = useState({
        informationPopup: false,
        confirmPopup: true,
        data: {}
    });
    const [checkBox, setCheckBox] = useState(null);
    const [storeData, setStoreData] = useState(null);
    const {
        storePanelData,
        setShowLocationPopup,
        setShareLocationSuccess,
        quickBuyPopup,
        isMobile,
        setShowStorePanel,
        setSingleStoreData,
        setDeliveryPreference,
        storeInformation,
        setStoreInformation
    } = useContext(LayoutContext);
    const { availableStoresLoader } = useContext(AppContext);

    const userGPSCoordinates = getCoordinates();
    const changeLocationClicked = () => {
        setShowLocationPopup(true);
        setShareLocationSuccess(true);
    };
    const showStoreinfoFunc = data => {
        setStorePopupInformation(prev => ({
            ...prev,
            informationPopup: true,
            confirmPopup: false,
            data: data
        }));
        setStoreData(data);
        setStoreInformation(data);
    };
    const farawayZoom =
        storePanelData && userGPSCoordinates
            ? getDistanceBetweenCoordinates(storePanelData, userGPSCoordinates) > 0.1
                ? false
                : true
            : false;
    const time =
        storePopupInformation?.data?.openHours?.Weekdays?.hourStart + " - " + storePopupInformation?.data?.openHours?.Weekdays?.hourEnd;
    const address =
        storePopupInformation?.data?.storeAddress +
        " " +
        storePopupInformation?.data?.stock +
        ", " +
        storePopupInformation?.data?.postalCode +
        " " +
        storePopupInformation?.data?.city +
        ", " +
        storePopupInformation?.data?.country;

    const SkeletonsArray = [1, 2, 3, 4, 5, 6, 7];
    const handleStates = () => {
        setStoreData(null);
        setStoreInformation(null);
        setStorePopupInformation(prev => ({
            ...prev,
            informationPopup: false,
            confirmPopup: true,
            data: null
        }));
        setCheckBox(null);
        setSingleStoreData(null);
    };

    return (
        <StorePanelStyles className="settings">
            <div className="panel-headers">
                <div className="order-nr-321325-j">Available stores</div>
                <div
                    className="btn-xs-secondary"
                    onClick={() => {
                        setShowStorePanel(false);
                        setDeliveryPreference("fastest");
                        handleStates();
                    }}>
                    <div className="button">Close</div>
                </div>
            </div>
            <div className="separator"></div>

            <TabChangerComponent
                availableStoresLoader={availableStoresLoader}
                storePanelData={storePanelData}
                selectBtn={selectBtn}
                setSelectBtn={setSelectBtn}
                handleStates={handleStates}
            />
            {storePanelData?.length > 0 ? (
                <StoresDataComponent
                    availableStoresLoader={availableStoresLoader}
                    selectBtn={selectBtn}
                    storePopupInformation={storePopupInformation}
                    address={address}
                    time={time}
                    userGPSCoordinates={userGPSCoordinates}
                    farawayZoom={farawayZoom}
                    storePanelData={storePanelData}
                    showStoreinfoFunc={showStoreinfoFunc}
                    isMobile={isMobile}
                    changeLocationClicked={changeLocationClicked}
                    quickBuyPopup={quickBuyPopup}
                    storeData={storeData}
                    SkeletonsArray={SkeletonsArray}
                    checkBox={checkBox}
                    setCheckBox={setCheckBox}
                    setStoreData={setStoreData}
                    storeInformation={storeInformation}
                />
            ) : (
                <EmptyStoresPanel availableStoresLoader={availableStoresLoader} />
            )}
            {storePanelData?.length > 0 ? (
                <div className="buttons">
                    {availableStoresLoader ? (
                        <Skeleton width={189} height={12.25} type={"footer"} />
                    ) : (
                        <div
                            className={storePopupInformation?.informationPopup || checkBox !== null ? "btn-solid" : "btn-lg-solid"}
                            onClick={() => {
                                setSingleStoreData(storeData);
                            }}>
                            <div className="frame-29590">
                                <div className="button">Select store</div>
                            </div>
                        </div>
                    )}
                </div>
            ) : null}
        </StorePanelStyles>
    );
}

const StoresDataComponent = ({
    availableStoresLoader,
    selectBtn,
    storePopupInformation,
    address,
    time,
    userGPSCoordinates,
    farawayZoom,
    storePanelData,
    showStoreinfoFunc,
    isMobile,
    changeLocationClicked,
    quickBuyPopup,
    storeData,
    SkeletonsArray,
    checkBox,
    setCheckBox,
    setStoreData,
    storeInformation
}) => {
    return (
        <div className="map">
            {availableStoresLoader && selectBtn === "map" ? (
                <Skeleton width={"100%"} height={"100%"} type={"product"} />
            ) : (
                <>
                    {storePopupInformation?.informationPopup && selectBtn === "map" ? (
                        <StoreCardOverlay
                            storePopupInformation={storePopupInformation}
                            address={address}
                            time={time}
                            storeInformation={storeInformation}
                        />
                    ) : null}
                    {storePopupInformation?.confirmPopup && selectBtn === "map" ? <SelectStoreOverlay /> : null}
                    {selectBtn === "map" ? (
                        //map component
                        <GoogleMaps
                            coords={userGPSCoordinates}
                            farawayZoom={farawayZoom}
                            allStoresCoords={storePanelData}
                            showStoreinfoFunc={showStoreinfoFunc}
                            userAddress={userGPSCoordinates}
                            isMobile={isMobile}
                            changeLocationClicked={changeLocationClicked}
                            quickBuyPopup={quickBuyPopup}
                            storeName={""}
                            isStoreLocation={true}
                            storeData={storeData}
                        />
                    ) : (
                        <ListComponent
                            availableStoresLoader={availableStoresLoader}
                            selectBtn={selectBtn}
                            SkeletonsArray={SkeletonsArray}
                            storePanelData={storePanelData}
                            checkBox={checkBox}
                            setCheckBox={setCheckBox}
                            setStoreData={setStoreData}
                        />
                    )}
                </>
            )}
        </div>
    );
};
const ListComponent = ({ availableStoresLoader, selectBtn, SkeletonsArray, storePanelData, checkBox, setCheckBox, setStoreData }) => {
    const isStoreOpen = storeData => {
        const isWeekday = new Date().getDay() >= 1 && new Date().getDay() <= 5;
        const isSaturday = new Date().getDay() === 6;

        const openHours = isWeekday
            ? storeData?.openHours?.weekdays
            : isSaturday
            ? storeData?.openHours?.saturdays
            : storeData?.openHours?.sundays;

        if (!openHours || !openHours?.hourStart || !openHours?.hourEnd) return false;

        //get current time in Norway Oslo with moment
        //const currentTime = moment().utcOffset("+0100").format("HH:mm");
        const currentTime = momentTimeZone.tz("Europe/Oslo").format("HH:mm");
        const hourStart = openHours?.hourStart; // "09:00"
        const hourEnd = openHours?.hourEnd; // "18:00"

        //check if current time in Oslo is between open hours
        return currentTime >= hourStart && currentTime <= hourEnd;
    };
    return (
        <div style={{ width: "100%" }}>
            {availableStoresLoader && selectBtn === "list" ? (
                <div style={{ height: "100%", display: "flex", gap: "8px", flexDirection: "column" }}>
                    {SkeletonsArray.map(item => (
                        <StoreSkeleton />
                    ))}
                </div>
            ) : (
                <ListStyle style={{ overflow: "auto", height: "calc(100dvh - 208px)" }}>
                    {storePanelData?.map(item => (
                        <div className="location-option-cardtrigger" style={{ left: "0px" }} key={item?._id}>
                            <div className="frame-295922853">
                                <img
                                    className="luan-j-shirt-cosmic-4-2"
                                    src={item?.facecadeURL ? item?.facecadeURL : item?.interiorURL}
                                    alt=""
                                />
                                <div className="frame-313869">
                                    <div className="frame-313868">
                                        <div className="gant-bogstadveien">{item?.storeName}</div>
                                        <div className="bogstadveien-37-0366-oslo-norwaydawdawdaw">
                                            {item?.storeAddress +
                                                " " +
                                                item?.stock +
                                                ", " +
                                                item?.postalCode +
                                                " " +
                                                item?.city +
                                                ", " +
                                                item?.country}
                                        </div>
                                    </div>
                                    <div>
                                        <span
                                            style={{
                                                color: isStoreOpen(item) ? "rgba(105, 194, 63, 1)" : "rgb(241, 70, 61)",
                                                fontWeight: 400
                                            }}>
                                            {isStoreOpen(item) ? "Open today:" : "Closed"}{" "}
                                        </span>{" "}
                                        {isStoreOpen(item) &&
                                            item?.openHours?.Weekdays?.hourStart + " - " + item?.openHours?.Weekdays?.hourStart}
                                    </div>
                                </div>
                            </div>
                            {checkBox === item?._id ? (
                                <img className="ellipse-2" src={Check} alt="" onClick={() => setCheckBox(null)} />
                            ) : (
                                <div
                                    className="ellipse-2"
                                    onClick={() => {
                                        setStoreData(item);
                                        setCheckBox(item?._id);
                                    }}></div>
                            )}
                        </div>
                    ))}
                </ListStyle>
            )}
        </div>
    );
};

const StoreCardOverlay = ({ storePopupInformation, address, time, storeInformation }) => {
    const isStoreOpen = () => {
        const dayOfWeek = new Date().toLocaleString("en-us", { weekday: "long" }).toLowerCase();
        const openHours = storeInformation?.openHours?.[dayOfWeek];

        if (!openHours || openHours.closedAllDay) return false;
        if (openHours.openAllDay) return true;

        const currentTime = momentTimeZone.tz("Europe/Oslo").format("HH:mm");
        const hourStart = openHours?.hourStart; // "10:00"
        const hourEnd = openHours?.hourEnd; // "19:00"
        return currentTime >= hourStart && currentTime <= hourEnd;
    };
    return (
        <div className="location-option-cardtrigger" style={{ left: "0px", right: " 0px", margin: "8px 13px" }}>
            <div className="frame-295922853">
                <img
                    className="luan-j-shirt-cosmic-4-2"
                    src={
                        storePopupInformation?.data?.facecadeURL
                            ? storePopupInformation?.data?.facecadeURL
                            : storePopupInformation?.data?.interiorURL
                    }
                    alt=""
                />
                <div className="frame-313869">
                    <div className="frame-313868">
                        <div className="gant-bogstadveien">{storePopupInformation?.data?.storeName}</div>
                        <div className="bogstadveien-37-0366-oslo-norwaydawdawdaw">{address}</div>
                        <div>
                            <span style={{ color: isStoreOpen() ? "rgba(105, 194, 63, 1)" : "rgb(241, 70, 61)", fontWeight: 400 }}>
                                {isStoreOpen() ? "Open today:" : "Closed"}
                            </span>{" "}
                            {isStoreOpen() && time}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SelectStoreOverlay = () => {
    return (
        <div className="tooltip-background" style={{ width: "98%", left: 5, right: 0 }}>
            <div className="frame-313703">
                <div className="frame-29476">
                    <div className="ellipse-86"></div>
                    <div className="frame-29475">
                        <img className="lightbulb-02" src={Bulb} alt="" />
                    </div>
                </div>
                <div className="frame-313702">
                    <div className="frame-313704">
                        <div className="tooltip-text">Click on a pin and confirm to select a store</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TabChangerComponent = ({ availableStoresLoader, storePanelData, selectBtn, setSelectBtn, handleStates }) => {
    return (
        <div className={availableStoresLoader || !storePanelData ? "tabs-level-1" : "tabs-levels"}>
            <div
                className={selectBtn === "map" ? "buttons-fixed-width" : "buttons-after"}
                onClick={() => {
                    setSelectBtn("map");
                    handleStates();
                }}>
                <div className="label">Map view</div>
            </div>
            <div
                className={selectBtn === "list" ? "buttons-width2" : "buttons-fixed-width2"}
                onClick={() => {
                    setSelectBtn("list");
                    handleStates();
                }}>
                <div className="label-active">List view</div>
            </div>
        </div>
    );
};
